module.exports = __webpack_public_path__ + "static/media/A3.fdfd6bf9.jpg";